/**
 * Service: Import API
 */
angular.module('acme.common.service.importJobExecutionsApi', [
  'acme.common.service.auth'
])
  .constant('JOB_EXECUTION_STATUS_TITLE', {
    uploaded: 'Uploaded',
    uploading: 'Uploading',
    created: 'Created',
    staging: 'Staging',
    staged: 'Staged',
    stagingError: 'Staging Error',
    validating: 'Validating',
    validated: 'Validation Completed',
    validationFailed: 'Validation Failed',
    validatedCompleteWithError: 'Validation Completed with Errors',
    externalValidatedCompleteWithError: 'ACME Validation Completed with Errors',
    externalValidating: 'Validating with ACME',
    externalValidated: 'ACME Validation Completed',
    externalValidationFailed: 'ACME Validation Failed',
    importing: 'Importing',
    imported: 'Imported',
    importFailed: 'Import Failed',
    exporting: 'Exporting',
    exportFailed: 'Export Failed',
    error: 'Error',
    unknown: 'Unknown',
    processed: 'Processed',
    processing: 'Processing',
    stopped: 'Stopped'
  })
  .constant('JOB_EXECUTION_ACTIVE_STATUSES', [
    'staging', 'validating', 'externalValidating', 'importing', 'processing'
  ])
  .constant('JOB_EXECUTION_ERROR_CODES', {
    UNKNOWN: {
      title: 'Unknown',
      description: 'Unknown error, further investigation is required'
    },
    MISSING: {
      title: 'Missing',
      description: 'Value is empty or column is missing'
    },
    MISSING_ORGANIZATION: {
      title: 'Missing Organization',
      description: 'Reference to an Organization which does not exist'
    },
    MISSING_ADDRESS: {
      title: 'Missing Address',
      description: 'Reference to an Address which does not exist'
    },
    MISSING_NAME: {
      title: 'Missing Name',
      description: 'Organization does not have a name'
    },
    COLUMN_TO_LONG: {
      title: 'Column too Long',
      description: 'Column has too many characters in it'
    },
    COLUMN_TOO_LONG: {
      title: 'Column too Long',
      description: 'Column has too many characters in it'
    },
    MISSING_CUSTOMER: {
      title: 'Missing Customer',
      description: 'Reference to a customer which does not exist'
    },
    MISSING_CONTACT: {
      title: 'Missing Contact',
      description: 'Reference to a contact which does not exist'
    },
    BAD_ACCOUNT_CATEGORY: {
      title: 'Unspecified Account Category',
      description: 'The Organisation Account Category must be <blank> or; reseller, groupbuyer or corpmembership'
    },
    MISSING_EXTERNAL_ID: {
      title: 'Missing External ID',
      description: 'Customer record External ID is missing'
    },
    BAD_ADDRESS_TYPE: {
      title: 'Incorrect Address Type',
      description: 'The Address Type must be Primary or Secondary'
    },
    INVALID_DATE: {
      title: 'Invalid Date Format',
      description: 'The Date is not in the correct format which is yyyy-MM-dd HH:mm:ss'
    },
    DUPLICATE_ID: {
      title: 'Duplicate ID',
      description: 'An ID in the ID Column is duplicated'
    },
    INVALID_RELATION: {
      title: 'Invalid Relationship',
      description: 'Reference to a Membership Card which does not exist'
    }
  })
  .constant('JOB_EXECUTION_ERROR_STATUSES', {
    CUSTOMER_FIXABLE: 'Customer Fixable',
    ACME_FIXABLE: 'ACME Fixable',
    UNKNOWN: 'Unknown'
  })
  .constant('JOB_EXECUTION_ERROR_TYPES', {
    INTERNAL: 'Internal',
    EXTERNAL: 'External',
    IMPORT: 'Import',
    STAGE: 'Stage'
  })
  .constant('JOB_EXECUTION_ERROR_MESSAGES_TYPES', {
    ERROR: {
      class: 'error fa fa-exclamation-circle',
      message: 'Blocker',
      title: 'Records with blocker errors will not be imported.'
    },
    WARNING: {
      class: 'warning fa fa-exclamation-triangle',
      message: 'Warning',
      title: 'Records with warning errors will be imported.'
    }
  })
  .provider('ImportJobExecutionsApiService', ImportJobExecutionsApiServiceProvider);

/**
 * Service: ImportJobExecutionsApiService
 * Import Job Execution API *Microservice* service
 * @constructor
 * @param {String} endpoint - the endpoint used
 * @param {Object} $http - angular $http service
 * @param AuthService
 * @return {ImportJobExecutionsApiService} -
 */
function ImportJobExecutionsApiService (endpoint, $http, AuthService) {

  var jobsEndpoint = endpoint + '/job',
    jobExecutionsEndpoint = endpoint + '/jobexecution',
    requestObject = {
      headers: {
        'x-tenant-id': AuthService.getCookie('user').tenantId
      }
    };

  return {
    list: list,
    create: create,
    get: get,
    getDownloadUrl: getDownloadUrl,
    update: update,
    presign: presign,
    uploadCsv: uploadCsv,
    stage: stage,
    validate: validate,
    validateExternally: validateExternally,
    importData: importData,
    errors: errors,
    available: available,
    remove: remove,
    stop: stop
  };

  /**
   * Calls the Job Executions Get All / List endpoint
   * @memberOf ImportJobExecutionsApiService
   * @public
   * @param {String} jobId - Job ID
   * @param {any} page 
   * @param {any} size 
   * @param {any} sort 
   * @return {Promise} promise that will resolve or reject with server response
   */
  function list(jobId, page, size, sort) {
    var _page = page || null,
      _size = size || null,
      _sort = sort || null;

    return $http.get(jobsEndpoint + '/' + jobId + '/executions', Object.assign(angular.copy(requestObject), {
      params: {
        page: _page,
        size: _size,
        sort: _sort
      }
    }));
  }

  /**
   * TODO
   * @param jobId
   * @returns {*}
   */
  function create(jobId) {
    return $http.post(jobExecutionsEndpoint, {
      jobId: jobId
    }, requestObject);
  }

  function get(id) {
    return $http.get(jobExecutionsEndpoint + '/' + id, requestObject);
  }
  
  function update(jobExecution) {
    return $http.put(jobExecutionsEndpoint + '/' + jobExecution.id, jobExecution, requestObject);
  }

  function presign(id, filename) {
    return $http.post(jobExecutionsEndpoint + '/' + id + '/presign/' + filename, null, requestObject);
  }

  /**
   * Upload CSV file to AWS S3 pre-signed URL
   * @param {String} url - AWS S3 pre-signed URL
   * @param file - file to upload
   */
  function uploadCsv(url, file) {
    return $http.put(url, file, { headers: { 'Content-Type': 'text/csv', 'x-amz-server-side-encryption': 'AES256' } });
  }

  function getDownloadUrl(id, type) {
    return jobExecutionsEndpoint + '/' + id + '/download/' + type;
  }

  function stage(id) {
    return $http.post(jobExecutionsEndpoint + '/' + id + '/stage', null, requestObject);
  }

  function validate(id) {
    return $http.post(jobExecutionsEndpoint + '/' + id + '/validate', null, requestObject);
  }

  function validateExternally(id) {
    return $http.post(jobExecutionsEndpoint + '/' + id + '/validate_external', null, requestObject);
  }

  function importData(id) {
    return $http.post(jobExecutionsEndpoint + '/' + id + '/import', null, requestObject);
  }

  function errors(id, page, size, sort) {
    var _page = page || null,
      _size = size || null,
      _sort = sort || null;

    return $http.get(jobExecutionsEndpoint + '/' + id + '/errors', Object.assign({}, requestObject, {
      params: {
        page: _page,
        size: _size,
        sort: _sort
      }
    }));
  }

  function available(id) {
    return $http.get(jobExecutionsEndpoint + '/' + id + '/available', requestObject);
  }

  function remove(id) {
    return $http.delete(jobExecutionsEndpoint + '/' + id, requestObject);
  }

  function stop(id) {
    return $http.post(jobExecutionsEndpoint + '/' + id + '/stop', null, requestObject);
  }
}

function ImportJobExecutionsApiServiceProvider () {}

ImportJobExecutionsApiServiceProvider.prototype.setEndpoint = function (endpoint) {
  this.endpoint = endpoint;
};

ImportJobExecutionsApiServiceProvider.prototype.$get = ['$http', 'AuthService', function ($http, AuthService) {
  return new ImportJobExecutionsApiService(this.endpoint, $http, AuthService);
}];

ImportJobExecutionsApiServiceProvider.$inject = [];
